exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button[data-v-414a10da]{border:0}.button__item[data-v-414a10da]{display:flex;align-items:center;justify-content:space-between;font-size:12px;font-weight:bold;transition:color .2s ease-out}.button__icon[data-v-414a10da]{flex:0 0 auto}.button__icon-font[data-v-414a10da]{color:#ffa014;font-size:1em}.button__title[data-v-414a10da]{flex:1 0 auto}.button__title[data-v-414a10da]:nth-child(n+2){margin-left:.5em}", ""]);

// exports
